import { render } from "./ManageMemberTab.vue?vue&type=template&id=a8413496&scoped=true&ts=true"
import script from "./ManageMemberTab.vue?vue&type=script&lang=ts"
export * from "./ManageMemberTab.vue?vue&type=script&lang=ts"

import "./ManageMemberTab.vue?vue&type=style&index=0&id=a8413496&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8413496"]])

export default __exports__